<template>
  <div>
    <CurrentStockAdjustTemp goods-option="S0106" goods-type="구매품"/>
  </div>

</template>

<script>
import CurrentStockAdjustTemp from './CurrentStockAdjustTemp'

export default {
  name: 'CurrentPurchaseStockAdjust',
  data: function () {
    return {
    }
  },
  components: {
    CurrentStockAdjustTemp
  },
  created () {
    console.log('************************')
  },
  mounted () {
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
  }
}
</script>

<style lang="scss">

</style>
